// extracted by mini-css-extract-plugin
module.exports = {"alert":"index-module_alert_3TNb1","content":"index-module_content_fuQth","center":"index-module_center_1KQKC","button":"index-module_button_3q5Ra"};